'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Loading
var SHOW_LOADING = exports.SHOW_LOADING = '@layer/loading/show';
var HIDE_LOADING = exports.HIDE_LOADING = '@layer/loading/hide';
// confirm
var SHOW_CONFIRM = exports.SHOW_CONFIRM = '@layer/confirm/show';
// alert
var SHOW_ALERT = exports.SHOW_ALERT = '@layer/alert/show';
// notice
var SHOW_NOTICE = exports.SHOW_NOTICE = '@layer/notice/show';
// clear
var CLEAR = exports.CLEAR = '@layer/clear';
// ok
var SHOW_OK = exports.SHOW_OK = '@layer/ok/show';
// fail
var SHOW_FAIL = exports.SHOW_FAIL = '@layer/fail/show';